import React, { Component } from 'react'
import classNames from 'classnames';
import PropTypes from 'prop-types';

import apiUrls from '../../../../apiUrls';
import { pushHistoryWithErrorNotFound, pushHistoryWithReview, urls } from '../../../../utils/routing'
import { 
    FIELD_VALIDATION_ERROR_TYPES, 
    HELP_DESCRIPTION_MAX_LENGTH, 
    USER_ROLES 
} from '../../../../utils/constants';
import { getUserId, getUsername, getUserRole } from '../../../../utils/functions'
import { 
    formatDateTime, 
    formatFileSize, 
    formatShortDate, 
    formatTime 
} from '../../../../utils/formatting';

import Textarea from '../../../Textarea/Textarea'
import Error from '../../../Error/Error';
import Caption from '../../../Caption/Caption';
import EditLabelError from '../../../Edit/EditLabelError/EditLabelError';
import FileUpload from '../../../FileUpload/FileUpload';
import ButtonBlueOutlineLarge from '../../../Buttons/ButtonBlueOutlineLarge/ButtonBlueOutlineLarge';
import TitleDialog from '../../../TitleDialog/TitleDialog';
import Tag from '../../../Tag/Tag';
import UnavailablePageWrapper from '../../../../containers/UnavailablePageWrapper/UnavailablePageWrapper';
import Main from '../../../Main/Main';
import TitleMajor from '../../../TitleMajor/TitleMajor';
import Back from '../../../Buttons/Back/Back';
import LinksPanel from '../../../LinksPanel/LinksPanel';
import { ActionDeleted } from '../../../ActionDeleted/ActionDeleted';
import { ActionShow } from '../../../ActionShow/ActionShow';
import { ActionHidden } from '../../../ActionHidden/ActionHidden';

import { 
    DIALOG_HELP_ATTENTION,
    DIALOG_HELP_FILE_FORMAT, 
    DIALOG_HELP_FILE_SIZE 
} from '../../../Dialogs/DialogHelp/translations';
import { 
    EDIT_UPLOAD_COMMON_ERROR, 
    EDIT_UPLOAD_INVALID_FILE_SIZE_ERROR, 
    EDIT_UPLOAD_INVALID_FILE_TYPE_ERROR, 
    FIELD_MAX_LIMIT_EXCEED_ERROR, 
    FIELD_MIN_LIMIT_EXCEED_ERROR,
    TO_LANDING
} from '../../../../translations';

import styles from './TicketView.module.css'


const isNumberRegex = /^\d+$/;

const message = PropTypes.shape({
    ticketId: PropTypes.number, // this id of ticket (many sms = question and answers)
    id: PropTypes.number, // this id of main sms (question)
    problemTypes: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
    })), // array in string with support-tags
    createdAt: PropTypes.string,
        updatedAt: PropTypes.string, // time of last answer for this question
    readUser: PropTypes.bool, // read OR not read user'om
    readAgent: PropTypes.bool, // read OR not read agent'om
    role: PropTypes.string, // role of sms owner - user, moderator, admin, robot, modCreator
    isAgent: PropTypes.bool,
    ownerId: PropTypes.number,
        ownerName: PropTypes.string,
    content: PropTypes.string,
    lang: PropTypes.string,
    isClose: PropTypes.bool,
    fileOriginalName: PropTypes.string, // if this sms has download image
    fileSrc: PropTypes.string, // if this sms has download image
    fileSize: PropTypes.number, // if this sms has download image
});

export default class TicketView extends Component {
    static propTypes = {
        spaId: PropTypes.number,
        spaUsername: PropTypes.string,

        ticketView: PropTypes.shape({
            filterParams: PropTypes.shape({
                type: PropTypes.number,
            }),
            /*modData: PropTypes.arrayOf(PropTypes.shape({
                modId: PropTypes.number,
                modVersionId: PropTypes.number,
                modVersion: PropTypes.string,
            })), // this we has, but how it write */
            ticketId: PropTypes.number,
            ownerId: PropTypes.number,
            isClose: PropTypes.bool,
            ownerName: PropTypes.string,
            problemTypes: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.number,
                title: PropTypes.string,
            })),
            createdAt: PropTypes.string,
            count: PropTypes.number,

            msg: PropTypes.arrayOf(message).isRequired,
        }).isRequired,

        isError: PropTypes.bool,
        isFetching: PropTypes.bool,
        isLoggedIn: PropTypes.bool.isRequired,

        fetchMessagesSupportPanel: PropTypes.func.isRequired,

        onSendAnswer: PropTypes.func.isRequired,
        onGetUserData: PropTypes.func.isRequired,

        onClickShowOrHiddenTicket: PropTypes.func.isRequired,
        onClickDeleteTicket: PropTypes.func.isRequired,
    }

    constructor() {
        super()

        this.state = {
            fileId: null,
            fileToken: null,
            fileErrorType: null,
            fileErrorMessage: null,

            isErrorProblemType: false,
            descriptionErrorMessage: null,
            isErrorMessage: false,
            message: null,
        }

        this.clearForm = this.clearForm.bind(this)
        this.handleMessageAnswerChange = this.handleMessageAnswerChange.bind(this)
        this.onFileDeleted = this.onFileDeleted.bind(this)
        this.handleMessageSend = this.handleMessageSend.bind(this)
    }

    componentDidMount() {
        if (getUserRole() === 'user' || getUserRole() === 'null') { //((!this.props.isLoggedIn && !this.props.isError) || this.props.isError) {
            pushHistoryWithErrorNotFound(this.props.history)
        }
        
        if ( isNumberRegex.test(window.location.pathname.slice(21, -1)) ) 
            this.props.fetchMessagesSupportPanel(parseInt(window.location.pathname.slice(21, -1)), this.props.ticketView.filterParams.type) // this.props.location
    }

    handleMessageAnswerChange = (message) => {
        this.setState({
            message,
            isErrorMessage: false,
            isErrorProblemType: false,
            descriptionErrorMessage: null,
        })
    }

    onFileDeleted = () => {
        this.setState({
            fileId: null,
            fileToken: null,
            fileErrorType: null,
            fileErrorMessage: null,
        })
    }

    handleFileDeleted = (type) => {
        return type ? this.onFileDeleted() : null
    }

    handleFileChange = (data, fileErrorType) => {
        let fileErrorMessage = null
        if (fileErrorType) {
            fileErrorMessage = EDIT_UPLOAD_COMMON_ERROR
            if (fileErrorType === FIELD_VALIDATION_ERROR_TYPES.FILE_TYPE_ERROR) {
                fileErrorMessage = EDIT_UPLOAD_INVALID_FILE_TYPE_ERROR
            } else if (fileErrorType === FIELD_VALIDATION_ERROR_TYPES.FILE_SIZE_ERROR){
                fileErrorMessage = EDIT_UPLOAD_INVALID_FILE_SIZE_ERROR
            }
        }

        if (data === null) {
            this.setState({
                fileId: null,
                fileToken: null,
                fileErrorType,
                fileErrorMessage,
            })
        } else {
            this.setState({
                fileId: data[0].id,
                fileToken: data[0].access_token,
                fileErrorType,
                fileErrorMessage,
            })
        }
    }

    clearForm = () => {
        this.setState({
            fileId: null,
            fileToken: null,
            fileErrorType: null,
            fileErrorMessage: null,

            isErrorProblemType: false,
            descriptionErrorMessage: null,
            isErrorMessage: false,
            message: null,
        })
    }

    handleMessageSend = () => {
        let hasError = false
        
        if (!this.state.message || this.state.message.length > HELP_DESCRIPTION_MAX_LENGTH) {
            this.setState({
                isErrorProblemType: true,
            })
            if (!this.state.message) {
                this.setState({
                    descriptionErrorMessage: FIELD_MIN_LIMIT_EXCEED_ERROR(1),
                })
            } else if (this.state.message.length > HELP_DESCRIPTION_MAX_LENGTH) {
                this.setState({
                    descriptionErrorMessage: FIELD_MAX_LIMIT_EXCEED_ERROR(HELP_DESCRIPTION_MAX_LENGTH),
                })
            }
            hasError = true
        }

        if (hasError) {
            return
        }

        const data = { ...this.state, ticketId: this.props.ticketView.ticketId, agentId: getUserId() }
        this.clearForm()
        this.props.onSendAnswer(data)
    }

    handleClickUserName = (ownerId) => {
        this.props.onGetUserData(ownerId)
    }

    handleClickImage = (src) => {
        window.open(src, '_blank');
    }

    handleClickShowOrHidden = () => {
        this.props.onClickShowOrHiddenTicket(this.props.ticketView.ticketId, this.props.ticketView.isClose)
    }

    handleClickDeleteTicket = () => {
        this.props.onClickDeleteTicket(this.props.ticketView.ticketId)
    }

    handleClickModTitle = () => {
        pushHistoryWithReview(this.props.history, this.props.ticketView.modData.modId)
    }

    checkName = (name) => {
        return getUsername(true) === name ? `${name} (Вы)` : name // ? `${name} (Вы)` : name
    }

    renderTags() {
        const isDisabled = false//this.state.isCheckedAll && !this.state.problemIds.includes(item.id)

        const type = this.props.ticketView.filterParams.type === -1 ? 'yellow' : 'warning' // 'light', 'lesta', 'blue', 'warning', 'yellow'
        
        return this.props.ticketView.problemTypes.map((item, index) => {
            //const isDisabled = this.state.isCheckedAll && !this.state.problemIds.includes(item.id)
            return (
                <div className={styles.tag} key={`problem-tag-${item.id}-${index}`}>
                    <Tag
                        caption={item.title}
                        id={item.id}
                        //isChecked={this.state.problemIds.includes(item.id)}
                        isDisabled={isDisabled}
                        isError={false}//{this.state.isErrorProblemType}
                        type={type}

                        //isSupport={true}

                        onClick={() => {}}
                    />
                </div>
            )
        })
    }

    renderErrorMessage() {
        return this.state.descriptionErrorMessage ? (
            <EditLabelError message={this.state.descriptionErrorMessage} />
        ) : null
    }

    renderFileErrorMessage() {
        return this.state.fileErrorMessage ? (
            <div className={styles.fileError}>
                <EditLabelError message={this.state.fileErrorMessage} />
            </div>
        ) : null
    }

    renderButtonShowOrHidden() {
        return this.props.ticketView.isClose ? (
            <span className={styles.ticket_adminButtons__btn} title="Открыть тикет">
                <ActionShow onClick={this.handleClickShowOrHidden} />
            </span>
        ) : (
            <span className={styles.ticket_adminButtons__btn} title="Закрыть тикет">
                <ActionHidden onClick={this.handleClickShowOrHidden} />
            </span>
        )
    }

    renderButtonDeleteTicket() {
        return (
            <span className={styles.ticket_adminButtons__btn} title="Удалить тикет">
                <ActionDeleted onClick={this.handleClickDeleteTicket} />
            </span>
        )
    }

    renderAdminsButtons() {
        return (
            <div className={styles.ticket_adminButtons}>
                <span>Управление: </span>
                {this.renderButtonShowOrHidden()}
                {this.renderButtonDeleteTicket()}
            </div>
        )
    }

    renderModData() {
        return (
            <div className={styles.modData}>
                <div className={styles.modData__desc}>Жалоба на мод</div>
                <div className={styles.modData__content}>
                    Название : <span className={styles.modData__modTitle} onClick={this.handleClickModTitle} title="Открыть страницу мода">{this.props.ticketView.modData.modTitle}</span>
                </div>
                <div className={styles.modData__content}>
                    Версия мода : {this.props.ticketView.modData.modVersion}
                </div>
            </div>
        )
    }

    renderMessageAnswerBlock() {
        const url = `https://tankimods.net${apiUrls.reportFileUpload}/`;

        const isErrorFileFormat = this.state.fileErrorType === FIELD_VALIDATION_ERROR_TYPES.FILE_TYPE_ERROR
        const isErrorFileSize = this.state.fileErrorType === FIELD_VALIDATION_ERROR_TYPES.FILE_SIZE_ERROR
        
        const numberTicket = this.props.ticketView.ticketId || '???'
        const ownerName = this.props.ticketView.ownerName || '???'

        return this.props.ticketView.count !== 0 ? (
                <div>
                    <div id="ticket__header">
                        <TitleDialog>
                            <React.Fragment>
                                Тикет id: <span>{numberTicket}</span> от <span style={{cursor:'pointer', borderBottom:'1px dashed var(--all-text-color)'}} onClick={() => this.handleClickUserName(this.props.ticketView.ownerId)}>{ownerName}</span>
                            </React.Fragment>
                        </TitleDialog>
                        <div className={styles.created__time} title={`поступил в ${formatTime(this.props.ticketView.createdAt)}`}>{formatDateTime(this.props.ticketView.createdAt)}</div>
                        <div className={styles.tags}>
                            {this.renderTags()}
                        </div>
                        { this.props.ticketView.filterParams.type === 0 ? this.renderModData() : null }
                    </div>
                    { !this.props.ticketView.isClose ? (
                            <div className={styles.form}>
                                <div className={styles.caption}>
                                    <Caption isRequired isError={this.state.isErrorMessage}>Сообщение: </Caption>
                                </div>
                                <Textarea
                                    rows={4}
                                    isError={this.state.isErrorMessage}
                                    value={this.state.message}
                                    onChange={this.handleMessageAnswerChange}
                                />
                                {this.renderErrorMessage()}
                                <div className={styles.fileUpload}>
                                    <FileUpload 
                                        isSupport={true} // parameter for support/help files
                                        url={url}
                                        fieldName="source"
                                        summary={(
                                            <span>
                                                <span className={styles.fileUploadSummary}>
                                                    {DIALOG_HELP_FILE_FORMAT(isErrorFileFormat)}
                                                </span>
                                                <span className={styles.fileUploadSummary}>
                                                    {DIALOG_HELP_FILE_SIZE(isErrorFileSize)}
                                                </span>
                                            </span>
                                        )}
                                        onFileDeleted={this.handleFileDeleted}
                                        onUploadCompleted={this.handleFileChange}
                                    />
                                    {this.renderFileErrorMessage()}
                                    <p className={styles.attention}>
                                        {DIALOG_HELP_ATTENTION}
                                        {/* {DIALOG_HELP_ATTENTION(getPrivacyPolicyUrlByRealm(this.props.realm))} */}
                                    </p>
                                    <ButtonBlueOutlineLarge onClick={this.handleMessageSend}>Отправить</ButtonBlueOutlineLarge>
                                    <hr className={styles.hr} />
                                </div>
                            </div>
                        ) : (
                            <div className={classNames(styles["conversation-post-content_title"], styles["conversation-post-content_title__main"])}>
                                <span data-msgid="Closed" data-current-language="ru">Закрыт</span>
                            </div>
                        )
                    }
                </div>
        ) : null
    }

    renderUserImage(item) {
        return (
            <img width="32" height="32" alt={item.ownerName} srcSet="https://img.beget.com/b/w:32/h:32/plain/cp/assets/img/common/avatar.png@.webp 1x, https://img.beget.com/b/w:64/h:64/plain/cp/assets/img/common/avatar.png@.webp 2x" className={styles.image__rounded_full} src="https://img.beget.com/b/w:32/h:32/plain/cp/assets/img/common/avatar.png@.webp" />
        )
    }

    renderAgentImage(item) {
        return (
            <div className={styles.message_logo__icon} style={{width:'32px', height:'32px'}}>
                <img alt="agent_image" className={styles.message_logo__agent} src="https://tankimods.net/documents/img/call-center.png"></img>
                {/* <svg xmlns="http://www.w3.org/2000/svg" className={styles.message_logo__svg} viewBox="0 0 64 64" width="32" height="32" fill="currentColor" title={item.ownerName}>
                    <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="m62.82 47.5-4.063 8c-1.572 3.56-4.101 3.993-8.025 4-.067 0-.135.007-.2.02l-3.883.789c-.356.072-.632.34-.817.654a2.477 2.477 0 0 1-2.142 1.228h-7.272c-1.399 0-2.532-1.115-2.532-2.49v-2.896c0-1.375 1.133-2.49 2.532-2.49h7.272c.949 0 1.75.523 2.175 1.286.16.286.393.537.706.634l3.914 1.22c.096.03.196.045.297.045 2.204 0 5.078-.041 5.944-2l4.063-8c1.097-2.484-2.418-5.36-3.465-5.927-.32-.173-.193.36-.305.705-1.1 3.392-2.394 5.39-4.357 5.222h-6.095c-3.015 0-4.064-1.454-4.064-6 0-2.388.74-6.99 1.326-10.265.41-2.286 2.144-4.089 4.399-4.644l3.62-.89c.47-.117.799-.554.776-1.039a38.402 38.402 0 0 0-.007-.143.956.956 0 0 0-.149-.467c-4.083-6.386-12.456-10.774-22.155-10.774-9.7 0-18.074 4.389-22.156 10.775a.957.957 0 0 0-.148.467L8 24.666a1.02 1.02 0 0 0 .774 1.034l3.613.889c2.26.556 3.996 2.365 4.404 4.656.587 3.302 1.33 7.936 1.33 10.255 0 3.834-1.027 5.738-4.063 6H7.964c-2.291 0-3.522.186-6.096-10-1.962-7.768.415-10.738 1.523-11.654.292-.241.512-.577.545-.955C4.406 19.553 9.366 1.5 30.313 1.5c20.89 0 25.879 17.965 26.372 23.348.037.4.282.75.617.972 1.29.862 4.121 3.668 1.754 10.83-.161.485.056 1.012.489 1.285.766.482 1.187.991 1.836 1.966 1.596 2.392 2.598 4.974 1.44 7.599Zm-32.507-42c-13.837 0-19.053 6.645-21.051 12.32-.355 1.009 1.046 1.65 1.813.907C15.62 14.32 22.54 11.5 30.313 11.5c7.772 0 14.69 2.82 19.235 7.224.767.744 2.168.102 1.813-.906C49.36 12.143 44.14 5.5 30.313 5.5Z"></path>
                </svg> */}
            </div>
        )
    }

    renderButtons(item) {
        return (
            <div className={styles.buttons}>
                {/* <button type="button" id="btn-edit-msg">Изменить</button> */}
                <button type="button" id="btn-delete-msg" onClick={() => this.props.onDeleteMessage(item.id, item.ticketId)}>Удалить</button>
                {/* <button type="button" className={styles.button__like} st="post-item-like-button">
                    <span className={styles.button__content}>
                        <div style={{width:'16px', height:'16px', color:'var(--all-text-color)'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" className={styles.style3} width="16" height="16" fill="currentColor">
                                <path fill="currentColor" d="m8.572 3.095-.574.57-.576-.571A3.778 3.778 0 0 0 4.762 2c-.998 0-1.955.393-2.66 1.093A3.714 3.714 0 0 0 1 5.732c0 .989.396 1.938 1.102 2.637l5.525 5.479a.527.527 0 0 0 .742 0l5.53-5.48C14.605 7.668 15 6.72 15 5.73c0-.989-.396-1.937-1.101-2.637A3.768 3.768 0 0 0 11.236 2a3.793 3.793 0 0 0-2.664 1.095Zm4.583 4.538-5.157 5.111-5.154-5.11a2.688 2.688 0 0 1-.805-1.905 2.67 2.67 0 0 1 .795-1.908 2.714 2.714 0 0 1 1.925-.788 2.732 2.732 0 0 1 1.92.798l.95.941a.525.525 0 0 0 .752-.008l.933-.933a2.729 2.729 0 0 1 3.77.065 2.68 2.68 0 0 1 .072 3.737Z"></path>
                            </svg>
                        </div>
                    </span>
                </button> */}
            </div>
        )
    }

    sliceText = (text, slicer = 18) => { // 18
        let sliced = text;
        if (text) {
            if (text.length > slicer) {
                let lastDotIndex = text.lastIndexOf('.');
                let trimmedString, format
                if (lastDotIndex !== -1) {
                    trimmedString = text.slice(0, lastDotIndex);
                    format = text.slice(lastDotIndex);
                    sliced = trimmedString.slice(0, slicer)+'... '+format
                } else {
                    sliced = text.slice(0, slicer)+'... ';
                }
            }
        }

        return sliced;
    }

    renderFileBlock(item) {
        return (<>
            <div style={{color:'#a1a1aa', fontSize:'.875rem'}}>Приложенные файлы:</div>
            <div className={styles.message_attached}>
                <span className={classNames(styles.message_attached__file)} draggable="false" tabIndex="0" onClick={() => this.handleClickImage(item.fileSrc)}>
                    <span className={styles.message_attached__file__overlay}></span>
                    <span className={styles.message_attached__file__underlay}></span>
                    <div className={styles.message_attached__file__content}>{this.sliceText(item.fileOriginalName)}</div>
                    <div className={styles.message_attached__file__size}>{formatFileSize(item.fileSize)}</div>
                </span>
            </div>
            </>
        )
    }

    renderMessageItem(item) { // {item.isAgent ? 'Служба технической поддержки' : item.role}
        return (
            <div className={styles.wrapper_message} key={`post_`+item.id}>
                <div id={`post_`+item.id} className={item.isAgent ? classNames(styles.wrapper_message__agent) : classNames(styles.wrapper_message__user)} st="support-ticket-message">
                    {/* <div className={styles.message_logo}>
                        {item.isAgent ? this.renderAgentImage(item) : this.renderUserImage(item)}
                    </div> */}
                    <div className={styles.message_body}>
                        <div id={item.isAgent ? 'agent_name' : 'username'} style={{color: 'var(--all-text-color)'}}>
                            <div st="post-item-support-name">{this.checkName(item.ownerName)}</div>
                            <div className={styles.message_role} st="post-item-support-position">{item.isAgent ? 'Служба технической поддержки' : USER_ROLES[item.role]}</div>
                        </div>
                        <div id={item.isAgent ? 'agent_message' : 'user_message'} style={{color: 'var(--all-text-color)'}}>
                            <div className={styles.message_msg} st="post-item-text">{item.content}</div>
                        </div>
                        {item.fileSize && item.fileSrc ? this.renderFileBlock(item) : null}
                        <div className={styles.message_footer}>
                            <div className={styles.message_footer__time} title={`отправлено в ${formatTime(item.createdAt)}`} st="support-ticket-post-time">{formatShortDate(item.createdAt)}</div>
                            {item.isAgent ? this.renderButtons(item) : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderMessages() {
        return this.props.ticketView.count !== 0 ? this.props.ticketView.msg.map((item) => this.renderMessageItem(item)) : <Error>Упс! Ошибка загрузки данных</Error>
    }

    renderBackButton() {
        return <Back caption={TO_LANDING} to={urls.landing} location={this.props.location} />
    }

    renderUrlLinker() {
        let params
        if (isNumberRegex.test( this.props.location.pathname.slice(21, -1) )) { // Number.isInteger(parseInt( this.props.location.pathname.slice(21, -1) ))
            params = this.props.location.pathname.slice(0, 21)
                .slice(1, -1)
                .split('/')
            params.push(`Тикет № ${this.props.location.pathname.slice(21, -1)}`)
        } else {
            params = this.props.location.pathname
                .slice(1, -1)
                .split('/')
        }

        return params.length > 1 ? ( <LinksPanel names={params} /> ) : null
    }

    render() {
        if ((!window.__URLS__.pages.moderatorSection) && (getUserRole() !== 'admin')) {
            return <UnavailablePageWrapper />
        } else {
            return (getUserRole() === 'admin' || getUserRole() === 'moderator' || getUserRole() === 'robot') ? (
                <Main>
                    <div className={styles.head}>
                        {this.renderBackButton()}
                        <TitleMajor>
                            <span></span>
                            {this.renderUrlLinker()}
                        </TitleMajor>
                    </div>
                    <div className={styles.base}>
                        {this.renderAdminsButtons()}
                        {this.renderMessageAnswerBlock()}
                        {this.renderMessages()}
                    </div>
                </Main>
            ) : pushHistoryWithErrorNotFound(this.props.history)
        }
    }
}

